import underscored from 'underscore.string/underscored';

angular.module('gym.components').directive('stripePaymentDetails', function() {
  return {
    restrict: 'EA',
    scope: {
      paymentMethods: '=',
      setDefault: '&',
      remove: '&',
      reload: '&',
      permissions: '=',
      contact: '='
    },
    template: require('templates/components/contacts/wallet/stripe_payment_details.html.slim'),
    controller: ["$scope", "$modal", "AdminUserService", function($scope, $modal, AdminUserService) {
      $scope.adminHasPermission = AdminUserService.has;
      $scope.contactsType = function(type) {
        return `${underscored(type)}s`;
      };
      return $scope.unlink = function(item) {
        return $modal.open({
          template: require('templates/gyms/contacts/payment_details/unlink_stripe_payment_method_modal.html.slim'),
          resolve: {
            contact: function() {
              return $scope.contact;
            },
            item: function() {
              return item;
            },
            reload: function() {
              return $scope.reload;
            }
          },
          controller: ["$scope", "$modalInstance", "contact", "item", "reload", function($scope, $modalInstance, contact, item, reload) {
            $scope.contact = contact;
            $scope.item = item;
            $scope.unlink = function() {
              $scope.isLoading = true;
              return item.one('unlink_contact').remove().then(function() {
                reload();
                return $modalInstance.close();
              });
            };
            return $scope.cancel = function() {
              return $modalInstance.dismiss();
            };
          }]
        });
      };
    }]
  };
});
